export default "ALTER TABLE `invoices` ADD `reconciled_at` text;--> statement-breakpoint\nALTER TABLE `invoices` ADD `reconciled_item_count` integer;";